import { Box, Button, MenuItem, Select, Typography, styled } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useTestSuiteQuery } from "../../useQuery";
import { useQueryClient } from "@tanstack/react-query";
import {
  resetExecutionReport,
  setSelectedProduct,
  setSelectedTestSuite,
  setSelectedTestSuiteData,
} from "../../Redux/ExecutionReport/ExecutionReport";
import { DeleteIcon } from "../../components-new/icons";
import { useLocation } from "react-router-dom";
import { HelpIconButton } from "../../components-new/help/help-modal";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: "300px",
    },
  },
};

const StyledSelect = styled(Select)`
  border-radius: 5px;
  border: 1px solid #d1dbff;
  background-color: #ffffff;
  font-size: 16px;
  color: #2b3539;
  min-width: 200px;
  max-height: 300px;

  .MuiSelect-select {
    padding: 13px 15px;
  }
`;

const SuiteReportSelection = ({
  products,
  setTestSuiteName,
  refetchTestSuiteResults,
  setPageno,
  setRefreshFlag,
  removeheader,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const path = location.pathname;
  const queryClient = useQueryClient();

  const [internalProduct, setInternalProduct] = useState("");
  const [testSuiteData, setTestSuiteData] = useState([]);

  const selectedProduct = useSelector((state) => state.executionSlice.selectedProduct);
  const selectedTestSuite = useSelector((state) => state.executionSlice.selectedTestSuite);

  const {
    data: testSuites,
    refetch: refetchTestSuite,
    isSuccess: isSuccessTestSuiteList,
  } = useTestSuiteQuery(internalProduct, {
    enabled: internalProduct !== "",
  });

  useEffect(() => {
    setInternalProduct(selectedProduct);
  }, [selectedProduct]);

  useEffect(() => {
    if (internalProduct) refetchTestSuite(internalProduct);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internalProduct]);

  useEffect(() => {
    if (selectedProduct && isSuccessTestSuiteList) {
      let flattened = testSuites.flat();
      setTestSuiteData(flattened);
      const filteredTS = flattened.filter((item) => item.idtest_suite === selectedTestSuite);

      dispatch(setSelectedTestSuiteData(filteredTS));
      setTestSuiteName(filteredTS?.[0]?.Test_Suite);
    }
  }, [
    dispatch,
    isSuccessTestSuiteList,
    selectedProduct,
    selectedTestSuite,
    setTestSuiteName,
    testSuites,
  ]);

  const handleProductChange = (event) => {
    setRefreshFlag(false);
    setInternalProduct(event.target.value);
    dispatch(setSelectedProduct(event.target.value));
    dispatch(setSelectedTestSuite(""));
    setPageno(1);
  };

  const handleTestSuiteChange = (event) => {
    const testSuiteId = event.target.value;
    setRefreshFlag(false);
    dispatch(setSelectedTestSuite(testSuiteId));
    refetchTestSuiteResults(testSuiteId);
    queryClient.invalidateQueries(["errorCodes"]);
    setPageno(1);
    removeheader();
  };

  const handleClearFilter = () => {
    removeheader();
    setRefreshFlag(false);
    dispatch(resetExecutionReport());
    setPageno(1);
  };

  return (
    <>
      <Box>
        <Box>
          <Typography color="#8089A8" fontSize="13px" fontWeight={500}>
            Application
          </Typography>
        </Box>
        <StyledSelect
          MenuProps={MenuProps}
          value={selectedProduct}
          onChange={handleProductChange}
          displayEmpty
        >
          <MenuItem disabled value="">
            Application
          </MenuItem>
          {products &&
            products.length > 0 &&
            (products ?? [{ label: "", value: "" }]).map((product) => (
              <MenuItem value={product.idproducts} key={product.idproducts}>
                {product.productname}
              </MenuItem>
            ))}
        </StyledSelect>
      </Box>

      {selectedProduct && (
        <Box>
          <Box>
            <Typography color="#8089A8" fontSize="13px" fontWeight={500}>
              Test Suite
            </Typography>
          </Box>
          <StyledSelect
            MenuProps={MenuProps}
            value={selectedTestSuite}
            onChange={handleTestSuiteChange}
            disabled={!testSuites}
            displayEmpty
          >
            <MenuItem disabled value="">
              Test Suite
            </MenuItem>
            {testSuites &&
              testSuites.length > 0 &&
              testSuiteData.map((testSuite) => (
                <MenuItem
                  key={`${testSuite.Test_Suite}-${testSuite.idtest_suite}`}
                  value={testSuite.idtest_suite}
                >
                  {testSuite.Test_Suite}
                </MenuItem>
              ))}
          </StyledSelect>
        </Box>
      )}

      <Button
        variant="outlined"
        startIcon={<DeleteIcon />}
        size="medium"
        onClick={handleClearFilter}
        sx={{
          color: "#828286",
          background: "#ffffff",
          height: "55px",
          border: "1px solid #E2E6F3",
          outline: 0,
          textTransform: "capitalize",
          mt: 2.5,
        }}
      >
        Clear filter
      </Button>

      <div className="mt-4">
        <HelpIconButton path={path} />
      </div>
    </>
  );
};

export default SuiteReportSelection;
